import { useContext } from 'react';

import ShopifyRsvpContext from './ShopifyRsvpContext';

export default function useShopifyRsvpContext() {
  return useContext(ShopifyRsvpContext);
}
